<template>
    <div class="TutorialDialogue">
        <div class="td-container">
            
            <button class="td-close" @click="toggleTutorialDialogue()"/>

            <img class="td-logo" :src="publicPath+'/media'+mediaURL+logoURL" alt=""/>

            <div id="mySwiper" class="swiper mp-gallery">
                <div class="swiper-wrapper">
                    
                    <div class="swiper-slide">
                        <div class="td-slide">
                            <div class="td-slide-title">{{$t("tutorialSlide1_title")}}</div>
                            <div class="td-slide-text">{{$t("tutorialSlide1")}}</div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="td-slide">
                            <img class="td-slide-icon" src="@/assets/flux360-Tutorial_scroll.svg" alt="">
                            <div class="td-slide-title">{{$t("tutorialSlide2_title")}}</div>
                            <div class="td-slide-text">{{$t("tutorialSlide2")}}</div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="td-slide">
                            <img class="td-slide-icon" src="@/assets/flux360-Tutorial_scroll2.svg" alt="">
                            <div class="td-slide-title">{{$t("tutorialSlide3_title")}}</div>
                            <div class="td-slide-text">{{$t("tutorialSlide3")}}</div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="td-slide">
                            <img class="td-slide-icon" src="@/assets/Tutorial_blue.svg" alt="">
                            <div class="td-slide-title">{{$t("tutorialSlide4_title")}}</div>
                            <div class="td-slide-text">{{$t("tutorialSlide4")}}</div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="td-slide">
                            <img class="td-slide-icon" src="@/assets/Fullscreen_blue.svg" alt="">
                            <div class="td-slide-title">{{$t("tutorialSlide5_title")}}</div>
                            <div class="td-slide-text">{{$t("tutorialSlide5")}}</div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="td-slide">
                            <img class="td-slide-icon" src="@/assets/contact.svg" alt="">
                            <div class="td-slide-title">{{$t("tutorialSlide6_title")}}</div>
                            <div class="td-slide-text">{{$t("tutorialSlide6")}}</div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="td-slide">
                            <img class="td-slide-icon" src="@/assets/InhaltsElemente.svg" alt="" style="width: auto !important;">
                            <div class="td-slide-title">{{$t("tutorialSlide7_title")}}</div>
                            <div class="td-slide-text">{{$t("tutorialSlide7")}}</div>
                        </div>
                    </div>

                    <div class="swiper-slide">
                        <div class="td-slide">
                            <img class="td-slide-icon" src="@/assets/icShop blue.svg" alt="">
                            <div class="td-slide-title">{{$t("tutorialSlide8_title")}}</div>
                            <div class="td-slide-text">{{$t("tutorialSlide8")}}</div>
                        </div>
                    </div>

                </div>
            </div>

            <div class="td-navigation">
                <div class="td-navigation-swiper">
                    <div class="td-pagination-arrow td-pagination-arrow-left"/>
                    <div id="swiper-pagination"/>
                    <div class="td-pagination-arrow td-pagination-arrow-right"/>
                </div>

                <div class="td-confirm">
                    <div class="td-confirm-button" @click="toggleTutorialDialogue()">{{$t("Abschließen")}}</div>
                </div>
            </div>

        </div>  
    </div>  
</template>

<style>
.TutorialDialogue{
    width: 100%;
    height: 100%; 
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    background: rgba(0, 0, 0, 0.4);
}
.td-container{
    position: absolute;
    background: rgba(255, 255, 255, 0.9);
    width: min(95vw, 480px);
    height: min(75vh, 600px);
    overflow: hidden;
    border-radius: 10px;
    text-align: center;
    /* border-top-right-radius: 12px; */
}
.td-logo{
    margin: auto;
    width: min(40%, 40vh);
    height: 40%;
    margin-top: min(50px, 5vh);
}

/* Swiper */
.mp-gallery{
    height: 70%;
    width: 100%;
}
.swiper-slide{
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}
.td-slide{
    height: 100%;
    width: 80%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: var(--primaryColor);
}
.td-slide-icon{
    width: 25% !important;
    height: 25% !important;
    margin-bottom: min(30px, 2vh);
}
.td-slide-title{
    text-align: center;
    width: 100%;
    margin-bottom: min(12px,2vh);
    font: normal normal 100 clamp(1rem, min(5vw,3vh) + 0.25rem, 1.7rem) Oswald;
    text-transform: uppercase;
    letter-spacing: 1.89px;
    font-weight: bolder;
}
.td-slide-text{
    text-align: center;
    align-self: flex-start;
    width: 100%;
    font-weight: lighter;
    font: normal normal 500 clamp(0.8rem, min(5vw,2.8vh) + 0.17rem, 1.6rem) Roboto;
}

/* Swiper Navigation */
.td-navigation{
    position: absolute;
    z-index: 2;
    bottom: 0;
    width: 100%;
    margin-bottom: 20px;
}
.td-navigation-swiper{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
}
#swiper-pagination{
    display: flex;
    justify-content: center;
    width: auto;
}
.TutorialDialogue .swiper-pagination-bullet{
    width: min(25px,min(5vh,5vw)) !important;
    height: min(25px,min(5vh,5vw)) !important;
    background: transparent;
    border: 2px solid var(--primaryColor);
    opacity: 1;
    transition: background .2s ease, border .2s ease;
}
.TutorialDialogue .swiper-pagination-bullet:first-child{
    margin-left: 0 !important;
}
.TutorialDialogue .swiper-pagination-bullet-active{
    background: var(--primaryColor);
}

.td-pagination-arrow{
    margin: 0 10px;
    cursor: pointer;
    border: solid var(--primaryColor);
    border-width: 0 5px 5px 0;
    display: inline-block;
    padding: 7px;
    transition: border .3s ease;
}
.td-pagination-arrow:hover{
    border-color: #123866;
}
.td-pagination-arrow-left{
    transform: rotate(135deg);
}
.td-pagination-arrow-right{
    transform: rotate(-45deg);
}

/* Confirm Buttpn */
.td-confirm{
    width: 40%;
    margin: auto;
}
.td-confirm-button{
    padding: 5px 20px;
    border: 2px solid var(--primaryColor);
    color: var(--primaryColor);
    font-size: 14px;
    cursor: pointer;
    border-radius: 5px;
    transition: background .2s ease, color .2s ease;
    text-align: center;
}
.td-confirm-button:hover{
    background: var(--primaryColor);
    color: white;
}

/* Close Icon */
.td-close{
    position: absolute;
    right: 0px;
    top: 0px;
    width: 50px;
    height: 50px;
    z-index: 2;

    background: var(--primaryColor);
    border: none;
    /* border-top-right-radius:10px; */
    transition: background .2s ease;
    cursor: pointer;
}
.td-close:before, .td-close:after{
    content: ' ';
    position: absolute;
    top: 50%;
    left: 50%;
    height: 22px;
    width: 2px;

    background-color: white;
    transition: background .2s ease;
}
.td-close:before{
    transform: translate(-50%,-50%) rotate(45deg);
}
.td-close:after{
    transform: translate(-50%,-50%) rotate(-45deg);
}
.td-close:hover{
    background: var(--primaryColor);
}
.td-close:hover:after, .td-close:hover::before{
    background: white;
}
@media screen and (height <= 800px){
    .swiper-slide{
        justify-content: start;
    }
    .td-slide{
        margin-top: 2vh;
        justify-content: start;
    }
}
</style>
    
<script>
import {mapGetters} from 'vuex';

import Swiper , { Pagination, Navigation } from 'swiper';
import 'swiper/swiper.min.css'
import 'swiper/modules/pagination/pagination.min.css'
import 'swiper/modules/navigation/navigation.min.css'

import CommentOutline from 'vue-material-design-icons/CommentOutline.vue'

export default {
    components: {CommentOutline},
    inject: ["toggleTutorialDialogue"],
    data: function () {
        return {
            tutorialDialogueVisible: false,
            currentSwiperIndex: 0,
            publicPath: process.env.BASE_URL,
        }
    }, 
    computed: {
        ...mapGetters(['logoURL','mediaURL']),
    },
    mounted(){
        setTimeout(() => {
            this.swiper = new Swiper('#mySwiper',{
                modules: [Pagination,Navigation],
                spaceBetween: 50,
                direction: 'horizontal',
                clickable: true,
                mousewheel: true,
                observer: true,
                pagination: {
                    el: '#swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.td-pagination-arrow-right',
                    prevEl: '.td-pagination-arrow-left',
                },
            });
            this.swiper.on('slideChange', () => {
                this.currentSwiperIndex = this.swiper.activeIndex;
            });
        }, 0); 
    }
}

</script>